'use strict';

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const moment=require('pulsar-utils/dist-es6/time/moment');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DaysSinceLastIncidentDirective=class DaysSinceLastIncidentDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/statisticsPanels/daysSinceLastIncident/daysSinceLastIncidentTemplate'}
get controller(){return DaysSinceLastIncidentDirectiveController}
get objectBindings(){return['incidents','pathStartTime','dimensions','interval','homeTimezone','preventAnimations']}};let


DaysSinceLastIncidentDirectiveController=class DaysSinceLastIncidentDirectiveController{
constructor($scope,$timeout,dateService){
this._$scope=$scope;
this._$timeout=$timeout;
this._dateService=dateService;

const _redrawIfNew=(newType,oldType)=>{
if(!_.exists(newType)||newType===oldType){
return;
}
$timeout(()=>{
this._setupGraphViewData();
});
};

$scope.$watch('controller.incidents',_redrawIfNew);

this._setupGraphViewData();
}

_setupGraphViewData(){
const{
graphViewData,
daysSinceMostRecentIncident,
graphYAxisDomain,
graphXAxisDomain}=
StatisticsPanelHelpers.getDaysSinceLastIncidentGraphViewData(this.pathStartTime,this.incidents,this.homeTimezone,this.interval);

this.graphViewData=graphViewData;
this.daysSinceMostRecentIncident=daysSinceMostRecentIncident;
this.graphYAxisDomain=graphYAxisDomain;
this.graphXAxisDomain=graphXAxisDomain;
}};


module.exports=DaysSinceLastIncidentDirective;
//# sourceMappingURL=daysSinceLastIncidentDirective.js.map
